require('./_bootstrap');
require('cookieconsent');

/**
 * Here goes scripts, that will be executed on every page.
 * Scripts, that needs to bu run on particular pages should be
 * placed in route folders above this file.
 */

$.extend(DataTable.ext.classes, {
  sPageButton: 'btn btn-default ml-5'
});

$(() => {
  $('#lnswitcher').lnswitcher({
    onSelect: (selected) => {
      window.location.href = setLocaleUrl + selected;
    }
  });

  window.addEventListener('load', () => {
    const cookieLangs = ['en_Europe', 'en_GB', 'en_IE'];
    let enabled = false;
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const pageLanguage = $('#lnswitcher').find('.value').html();
    const userCookieAccepted = '<?php echo $this->layout()->cookieAccepted ?>' === '1';

    if (!userCookieAccepted) {
      if (cookieLangs.indexOf(pageLanguage) !== -1) {
        enabled = true;
      } else if (timezone.indexOf('Europe') !== -1) {
        enabled = true;
      }
    }

    window.cookieconsent.initialise({
      enabled,
      palette: {
        popup: {
          background: '#254b5e'
        },
        button: {
          background: '#b28f30',
          text: '#254b5e'
        }
      },
      theme: 'classic',
      onStatusChange() {
        if (this.hasConsented()) {
          $.get('/accept-cookies', null, (e) => {
            console.log(e);
          });
        }
      }
    });
  });
});
